import {Query} from './query';
import {IQueryable} from './types';

export const query = <T>(t: T[]): IQueryable<T> => new Query(t);
